'use client';
import { useRouter } from 'next/navigation';

import { Skeleton } from '@/slw/shared/ui/skeleton';
import { PackageOffer } from '@/slw/entities/package';

import { ExclusiveOfferingCard } from './exclusive-offering-card';

interface ExclusiveOfferingsProps {
  packageOffers: PackageOffer[];
  isLoading: boolean;
}
export function ExclusiveOfferings({ packageOffers, isLoading }: ExclusiveOfferingsProps) {
  const router = useRouter();

  const handleSelect = async (offering: PackageOffer) => {
    router.push(`/checkout?offerId=${offering.id}`);
  };

  const renderLoading = () => {
    return [1, 2, 3].map((i) => (
      <div key={i} className='flex items-center space-x-2.5'>
        <Skeleton className='h-16 w-16 rounded-full' />
        <div className='space-y-2'>
          <Skeleton className='h-4 w-32' />
          <Skeleton className='h-4 w-24' />
        </div>
      </div>
    ));
  };

  const renderOfferings = () => {
    return packageOffers?.map((offering) => (
      <ExclusiveOfferingCard key={offering.id} offering={offering} onSelect={handleSelect} />
    ));
  };

  return (
    <section
      className='w-full bg-primary my-12 py-10 md:py-12
      container mx-auto px-8 lg:px-16 2xl:px-0
      flex flex-col md:flex-row items-center md:items-stretch gap-6 justify-between'
    >
      {/* Left: Title & Subtitle */}
      <div className='flex flex-col justify-center gap-2.5'>
        <h2 className='text-3xl md:text-[2rem] font-bold text-white leading-[100%]'>
          Still Premium – Exclusive Offerings to you!
        </h2>
        <p className='text-lg font-semibold text-white leading-[150%]'>
          Great to have you in the network of Clovis Classics!
        </p>
      </div>
      {/* Right: Offerings Card */}
      <div
        className='bg-[#463928] rounded-md px-8 py-6
          flex flex-col gap-6 items-end'
      >
        {isLoading ? renderLoading() : renderOfferings()}
      </div>
    </section>
  );
}
